import { DEV_MODE } from "../game/constants";
import EventEmitter from "eventemitter3";

export enum dev_event {
  SKIP_TO_LEVEL = "skipLevelPlay",
  LEVEL_TRACKER = "levelTracker",
  EDIT_LEVEL = "editLevel",

  // For looking at the whole game art progression
  REQUEST_SNAPSHOT = "requestSnapshot",
  PLACE_SNAPSHOT = "placeSnapshot",

  // Recording module
  START_RECORDING = "startRecording",
  STOP_RECORDING = "stopRecording",
  SAVE_RECORDING = "saveRecording",
  PLAY_Recording = "playRecording",
  STOP_PLAYBACK = "stopPlayback",

  // Edit Paint Modes
  Paint_pencil = "paint_pencil",
  Paint_eraser = "paint_eraser",
  Paint_Select = "paint_select",
  Save_Editor_Level = "save_level",
  Paint_Selected_Resp = "paint_resp",
}

let devEventEmitter: EventEmitter | null = null;
if (DEV_MODE) {
  devEventEmitter = new EventEmitter();
  console.log("created dev event emitter");
}

export const getDevEmitter = () => devEventEmitter;
